import { Card, CardContent, Skeleton, Box } from '@mui/material';

export function DetailSkeleton() {
  return (
    <Box id="detail-skeleton">
      {/* Ticket Info Skeleton */}
      <Card sx={{ mb: 2 }}>
        <CardContent>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
            <Skeleton variant="text" width="60%" height={32} />
            <Skeleton variant="rounded" width={80} height={24} />
          </Box>
          <Skeleton variant="text" width="80%" />
          <Skeleton variant="text" width="60%" />
          <Skeleton variant="text" width="70%" />
        </CardContent>
      </Card>

      {/* Product Info Skeleton */}
      <Card sx={{ mb: 2 }}>
        <CardContent>
          <Skeleton variant="text" width="50%" height={28} />
          <Skeleton variant="text" width="90%" />
          <Skeleton variant="text" width="70%" />
          <Skeleton variant="text" width="80%" />
          <Skeleton variant="text" width="60%" />
        </CardContent>
      </Card>

      {/* Defect Line Skeleton */}
      <Card sx={{ mb: 2 }}>
        <CardContent>
          <Skeleton variant="text" width="30%" height={28} />
          <Skeleton variant="text" width="100%" />
          <Skeleton variant="text" width="100%" />
          <Skeleton variant="text" width="80%" />
          <Box sx={{ display: 'flex', gap: 1, mt: 2 }}>
            <Skeleton variant="rectangular" width={100} height={100} sx={{ borderRadius: 1 }} />
            <Skeleton variant="rectangular" width={100} height={100} sx={{ borderRadius: 1 }} />
            <Skeleton variant="rectangular" width={100} height={100} sx={{ borderRadius: 1 }} />
          </Box>
        </CardContent>
      </Card>

      {/* Notes Skeleton */}
      <Card sx={{ mt: 2 }}>
        <CardContent>
          <Skeleton variant="text" width="25%" height={24} />
          <Skeleton variant="text" width="100%" />
          <Skeleton variant="text" width="60%" />
        </CardContent>
      </Card>
    </Box>
  );
}
